







































































































































import {Component, Mixins} from 'vue-property-decorator';
import {cloneDeep} from 'lodash';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import excelConfig from '@/enums/ExcelSourceTypeEnum';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
@Component({
    components: {CDatepicker, CCheckbox, CSelect, CSimpleTable, CNumberField, CTextField, CEditDialog},
})
export default class FlexGridImporSettingstEditDialog extends Mixins(EditDialogMixin) {
    private initialData: any = null;
    private excelConfig = excelConfig;

    get pageNameRules() {
        return [
            (v: any) =>
                /(^[А-ЯЁа-яёЁA-Za-z0-9/(/)""/%№+-]+[А-ЯЁа-яёЁA-Za-z0-9/(/)""\s/%№+-]*$)|(^$)/.test(v) ||
                'Enter correct page name',
        ];
    }

    get checkboxRule() {
        return [(v: any) => typeof v === 'boolean' || 'enter correct value'];
    }

    init(data: any) {
        this.data = data;
        this.initialData = cloneDeep(data);
    }
    clear() {
        this.data = null;
        this.initialData = null;
    }
    resetNotSelectedOptions() {
        this.data.Columns.forEach((column: any, index: number) => {
            if (column.IdExcelSourceType === null) return;
            switch (column.IdExcelSourceType) {
                case excelConfig.defaultValue:
                    column.Value = this.initialData.Columns[index].Value;
                    column.ColumnIndex = this.initialData.Columns[index].ColumnIndex;
                    column.ColumnHeader = this.initialData.Columns[index].ColumnHeader;
                    break;
                case excelConfig.userValue:
                    column.ColumnIndex = this.initialData.Columns[index].ColumnIndex;
                    column.ColumnHeader = this.initialData.Columns[index].ColumnHeader;
                    break;
                case excelConfig.columnIndex:
                    column.Value = this.initialData.Columns[index].Value;
                    column.ColumnHeader = this.initialData.Columns[index].ColumnHeader;
                    break;
                case excelConfig.columnHeader:
                    column.Value = this.initialData.Columns[index].Value;
                    column.ColumnIndex = this.initialData.Columns[index].ColumnIndex;
            }
        });
    }

    beforeSave() {
        this.resetNotSelectedOptions();
    }

    getAvailableItems(item: any) {
        if (item.IsList && item.IsRequired) return [excelConfig.columnHeader];
        else if (!item.IsList && !item.IsRequired) return undefined;
        else if (!item.IsList && item.IsRequired)
            return [excelConfig.userValue, excelConfig.columnIndex, excelConfig.columnHeader];
        else if (item.IsList && !item.IsRequired) return [excelConfig.defaultValue, excelConfig.columnHeader];
    }
}
